import styled from 'styled-components';
import Button from '@/trio-ui/Button';

export const CustomButton = styled(Button)`
  margin: auto;
  text-transform: uppercase;
  height: 32px;
`;

export const Box = styled.div`
  text-align: center;
`;

export const Title = styled.h3`
  font-size: 26px;
  font-weight: 600;
  line-height: 30px;
  padding-top: 40px;
  color: ${(props) => props.theme.colors['neutral-50']};
  margin-bottom: 24px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 24px;
`;
